import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const Loader = ({ 
  spinning = true, 
  tip = "Loading...", 
  size = 48, 
  className = "",
  children 
}) => {
  const antIcon = <LoadingOutlined style={{ fontSize: size }} spin />;

  return (
    <Spin 
      indicator={antIcon} 
      spinning={spinning} 
      tip={tip}
      className={className}
    >
      {children}
    </Spin>
  );
};

export default Loader;
